<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 4c0-1.11.89-2 2-2 1.11 0 2 .89 2 2 0 1.11-.89 2-2 2-1.11 0-2-.89-2-2Zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0 0 17.81 7h-.12a2 2 0 0 0-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3Zm-7.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Zm-7-5.5c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2Zm2 16v-7h1.5V9c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v6h1.5v7h4Zm6.5 0v-4h1v-4c0-.82-.68-1.5-1.5-1.5h-2c-.82 0-1.5.68-1.5 1.5v4h1v4h3Z"
    />
  </svg>
</template>
